module.exports = __webpack_public_path__ + "static/media/26.a7533fc0.wav";